import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TrialBalanceReportSessionContainer  {
    _originalTypeClassName = "zERP.BO.TrialBalanceReportSessionContainer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TrialBalanceReportSessionContainer.translate = translateService;
}
this.Lines = [];
this.TrialBalanceReportSessionContainerKey = null;
this._key = this.TrialBalanceReportSessionContainerKey = 0; 
}

static translate: TranslateService;
_key: any;
Lines:any;
private _TrialBalanceReportSessionContainerKey:any;
get TrialBalanceReportSessionContainerKey(): any {
    return this._TrialBalanceReportSessionContainerKey;
  }
set TrialBalanceReportSessionContainerKey(value: any) {
    this._TrialBalanceReportSessionContainerKey = value;
    this._key = value;
  }
static setLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.Lines == null) $this.Lines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Lines.length > 0) {
                    Domain.TrialBalanceReportSessionContainer.removeLines($this, $this.Lines[0]);
                }

                Domain.TrialBalanceReportSessionContainer.addManyLines($this, copyItems);
            }
static addManyLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TrialBalanceReportSessionContainer.addLines($this, items[i]);
                }
            }
static addLines = ($this, item) => {
                if ($this.Lines == null) $this.Lines = [];
                if (item == null || $this.Lines.indexOf(item) > -1) return;
                $this.Lines.push(item);
}
static addRangeLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TrialBalanceReportSessionContainer.addLines($this, item));
            }
static removeLines = ($this, item) => {
                if ($this == null || $this.Lines == null || $this.Lines.indexOf(item) === -1) return;
                var _index = $this.Lines.indexOf(item);
                $this.Lines.splice(_index, 1);
}
static clearLines = ($this) => { $this.Lines = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TrialBalanceReportSessionContainerKey == null || $this.TrialBalanceReportSessionContainerKey == 0;
            }


}